

export default {
    API_HOST: process.env.REACT_APP_API_URL,
    TRANZILA_USERNAME: process.env.TRANZILA_USERNAME
};